// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3731":"460c4421","4548":"c38fef53","7074":"10c3cee7","12752":"460c4421","32622":"460c4421","49933":"be1e03da"}[chunkId] + ".chunk.css";
};